import { call, put, takeLatest, select } from 'redux-saga/effects';
import { createPractice, getPractices, showPractice, editPractice } from './index.reducer'
import { push } from 'connected-react-router'

import Api from '../services/ApiCaller'
import { showMessage  } from '../utils'
import { updateMe } from '../auth/index.web'
import { IAppState } from '../store/state.interface.web';

export function* getPracticesRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload)
    const { error, message } = res
    if (error) {
      yield put(getPractices.failure(message))
    } else {
      yield put(getPractices.success(res))
    }
  } catch (e) {
    yield put(getPractices.failure())
  }
}
function* getPracticeByIdRequest(api: Function, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload)
    const { error, message } = res
    if (error) {
      yield put(showPractice.failure(message))
    } else {
      yield put(showPractice.success(res))
    }
  } catch (e) {
    yield put(showPractice.failure())
  }
}

export function* CreatePracticeRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (error) {
      yield put(createPractice.failure(message))
    } else {
      yield put(createPractice.success(res))
    }
  } catch (e) {
    yield put(createPractice.failure())
  }
}

export function* editPracticeRequest(api: any, { payload }: any) {
  try {
    const { res = {} } = yield call(Api.callServer, api, payload, true)
    const { error, message } = res
    if (error) {
      yield put(editPractice.failure(message))
    } else {
      yield put(editPractice.success(res))
      showMessage('Practice upadated successfully')
      const state: IAppState = yield select()
      yield(put(updateMe.success({
        organization: res,
        id: state.login.user.id
      })))
      yield put(push(`/practices/${res.id}`))
    }
  } catch (e) {
    yield put(editPractice.failure())
  }
}

export default (api: any) => {
  const getPracticesApi = (data: any) => api.get('/organizations', data)
  const getPracticesByIdApi = (data: any) => api.get(`/organizations/${data.id}`)
  const editPracticesByIdApi = (data: any) => api.put(`/organizations/${data.id}`, data)
  const createPracticeApi = (data: any) => api.post(`/organizations/invite`, data)

  return [
    takeLatest(getPractices.TRIGGER, getPracticesRequest, getPracticesApi),
    takeLatest(
      showPractice.TRIGGER,
      getPracticeByIdRequest,
      getPracticesByIdApi
    ),
    takeLatest(editPractice.TRIGGER, editPracticeRequest, editPracticesByIdApi),
    takeLatest(createPractice.TRIGGER, CreatePracticeRequest, createPracticeApi)
  ]
}
